import DashboardLayout from "../components/DashboardLayout"
import UserManagement from "../components/users/UserManagement"
import Breadcrumb from "../components/Breadcrumb"

const UsersPage = () => {
  return (
    <DashboardLayout>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <Breadcrumb items={[{ label: "Dashboard", href: "/dashboard" }, { label: "User Management" }]} />

        <div style={{ marginBottom: "1.5rem" }}>
          <h1 style={{ fontSize: "1.875rem", fontWeight: "bold", marginBottom: "0.5rem" }}>User Management</h1>
          <p style={{ color: "var(--gray-500)" }}>Manage your users, create new accounts and define access rights.</p>
        </div>

        <UserManagement />
      </div>
    </DashboardLayout>
  )
}

export default UsersPage

